import type { QuestionVisibilityState } from "@/components/survey/Question";

import { isB2CPartner } from "../partners";

export const shouldShowSleepAndStressEatingQuestions = ({
  partnerInfo,
}: QuestionVisibilityState) => !isB2CPartner(partnerInfo);
